import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Switch
} from '@material-ui/core';
import { useAuth } from '../../context/auth';
import { useMessage } from "../../context/message";

export default function OverlayAccessDialog({ open, setOpen, user, fetchData, setFetchData}) {
  const { setMessage } = useMessage();
  const { auth } = useAuth()
  const [overlay, setOverlay] = useState(0);
  const [extendedOverlay, setExtendedOverlay] = useState(0);

  useEffect(() => {
    console.log('user; ' , user)
    if (user) {
      setOverlay(user.overlayAccess || 0);
      setExtendedOverlay(user.extendedOverlayAccess || 0);
    }
  }, [user,]);

  const handleSave = () => {
    console.log('saving')
    fetch(`/api/user/overlayAccess/${user.user_id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-access-token': sessionStorage.getItem('token')
      },
      body: JSON.stringify({
        overlayAccess: overlay,
        extendedOverlayAccess: extendedOverlay
      })
    })
    .then(response => auth(response))
    .then(response => {
      setMessage(response.message)
      setFetchData(!fetchData)
    })
    .catch(error => {
      setMessage({type: 'error', text: 'Error! Unable to change permissions'});
      console.error('Error:', error);
    })
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Overlay Access</DialogTitle>
      <DialogContent>
        <FormControlLabel
          control={
            <Switch
              checked={overlay === 1}
              onChange={() => setOverlay(overlay === 1 ? 0 : 1)}
              color="primary"
            />
          }
          label="Overlay Access"
        />
        <FormControlLabel
          control={
            <Switch
              checked={extendedOverlay === 1}
              onChange={() => setExtendedOverlay(extendedOverlay === 1 ? 0 : 1)}
              color="primary"
            />
          }
          label="Extended Overlay Access"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setOpen(false)} color="default">Cancel</Button>
        <Button onClick={handleSave} color="primary">Save</Button>
      </DialogActions>
    </Dialog>
  );
}
